import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import CaseIHImage from '../../../../assets/images/case_ih.jpg';
import JohnDeereImage from '../../../../assets/images/john_deere.png';
import { DimmedBackground } from '../../../../components/common/dimmed/DimmedBackground';
import { ToggleSwitchLarge } from '../../../../components/common/inputs/ToggleSwitchLarge';
import { usePutUsersMeMutation } from '../../../../hooks/api/user/mutations/usePutUsersMe.mutation';
import { usePopup } from '../../../../hooks/popup/usePopup';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';
import { useGetUserProfile } from '../../../../hooks/user/useGetUserProfile';
import { requestLogin } from '../../../../utils/modal/requestLogin.util';

interface ProductPendingAlarmModalProps {
  isShow: boolean;
  onClose: () => void;
  productTitle: string;
  isCaseIH?: boolean;
}

export const ProductPendingAlarmModal = ({
  isShow,
  onClose,
  productTitle,
  isCaseIH,
}: ProductPendingAlarmModalProps) => {
  const Popup = usePopup();
  const navigate = useNavigate();

  const { isUserLoggedIn } = useCheckUserLoggedIn();
  const { userProfile } = useGetUserProfile();

  const { mutate: putUsersMe } = usePutUsersMeMutation();

  const handleAlarmToggleClick = () => {
    ampli.마켓매물알림버튼클릭();

    if (!isUserLoggedIn) {
      requestLogin(Popup, navigate);
    } else if (window.ReactNativeWebView) {
      try {
        putUsersMe({ reqBody: { pushNotiApproval: true } });
      } catch (e) {
        // console.log(e);
      }
    } else {
      Popup.toast('푸시 알림을 받고 싶으시다면,\n앱 설치 이후 앱으로 접속해 주세요.');
      onClose();
    }
  };

  return (
    <>
      <DimmedBackground isShow={isShow} onClick={onClose}>
        <Card
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <HeaderImage src={isCaseIH ? CaseIHImage : JohnDeereImage} />
          <MiddleSection>
            <HeaderTitle>{'판매 예정 매물 알림'}</HeaderTitle>
            <HeaderProductTitle>{productTitle}</HeaderProductTitle>
            <ContentText>
              {
                '플루바가 직접 검수한 매물입니다.\n지금 입고 알림을 활성화 하시면,\n매물이 입고될 때 알림을 보내드립니다.'
              }
            </ContentText>
          </MiddleSection>
          <BottomSection>
            {!isUserLoggedIn || userProfile?.pushNotiApproval === false ? (
              <ToggleButtonSection>
                <ToggleButtonSectionBackground>
                  <ToggleButtonBackground>
                    <ToggleSwitchLarge isChecked={false} onClick={handleAlarmToggleClick} />
                  </ToggleButtonBackground>
                  <ToggleButtonText>{'알람 동의 하기'}</ToggleButtonText>
                </ToggleButtonSectionBackground>
              </ToggleButtonSection>
            ) : (
              <SuccessText>{'알림을 설정하셨어요\n판매가 시작될 때 알림을 보내드릴게요!'}</SuccessText>
            )}
          </BottomSection>
          <CloseButton onClick={onClose}>{'닫기'}</CloseButton>
        </Card>
      </DimmedBackground>
    </>
  );
};

const Card = styled.div`
  width: 316px;
  height: 608px;

  margin: auto;

  background-color: #212121;

  border-radius: 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const HeaderImage = styled.img`
  border-radius: 16px 16px 0px 0px;
`;

const MiddleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const HeaderTitle = styled.h1`
  font-weight: 800;
  font-size: 30px;
  line-height: 35.8px;

  color: #ffffff;
`;

const HeaderProductTitle = styled.h2`
  color: #ffffff;
  line-height: 19.09px;
  font-weight: 700;

  margin-top: 4px;
  margin-bottom: 16px;
`;

const ContentText = styled.pre`
  color: #ffffff;

  font-family: 'Pretendard';
  text-align: center;

  line-height: 19.09px;
  margin-bottom: 16px;
`;

const ToggleButtonSection = styled.div`
  width: 100%;
  height: 205px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const ToggleButtonSectionBackground = styled.div`
  width: 163px;
  height: 125px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: rgba(255, 255, 255, 0.05);

  border-radius: 16px;
`;

const ToggleButtonBackground = styled.div`
  width: 99px;
  height: 47px;

  background-color: #ffffff;

  border-radius: 16px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const ToggleButtonText = styled.span`
  color: #959595;
  font-weight: 300;
  font-size: 12px;
  line-height: 14.32px;
  margin-top: 16px;
`;

const CloseButton = styled.button`
  width: 100%;
  height: 48px;
  background-color: #2c2c2c;
  color: #ffffff;

  line-height: 19.09px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 0px 0px 16px 16px;
`;

const SuccessText = styled.pre`
  font-weight: 600;
  font-size: 16px;

  font-family: 'Pretendard';
  text-align: center;

  color: var(--font-color-secondary);
`;

const BottomSection = styled.div`
  padding: 0px 20px;
`;
